module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-portal-4.60f7687f.svg";